import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {SelectTarget} from "./target/target";
import {SelectOptions} from "./options/options";
import {SelectContainer} from "./container/container";
import {SelectLabel} from "./label/label";
import uuid from "react-uuid";

export class Select extends Component {
    static get propTypes() {
        return {
            name: PropTypes.string,
            label: PropTypes.string,
            value: PropTypes.string,
            options: PropTypes.array,
            disabled: PropTypes.bool,
            onChange: PropTypes.func,
        }
    }

    constructor(props) {
        super(props);
        this.id = uuid();
        this.state = {
            initSelectOptions: false,
        };

        this.handleOptionSelect = this.handleOptionSelect.bind(this);
        this.handleTargetClick = this.handleTargetClick.bind(this);
        this.handleDestroy = this.handleDestroy.bind(this);
    }

    handleOptionSelect(value) {
        this.props.onChange(this.props.name, value);
    }

    handleTargetClick() {
        if (this.props.disabled) {
            return;
        }

        this.setState({initSelectOptions: true})
    }

    handleDestroy() {
        this.setState({initSelectOptions: false});
    }

    render() {
        const {options, value, label, disabled} = this.props;
        const {initSelectOptions: init} = this.state;

        return (
            <SelectContainer elementClass={disabled ? 'select-disabled' : ''}>
                <SelectLabel text={label}/>
                <SelectTarget
                    id={this.id}
                    value={value}
                    options={options}
                    onClick={this.handleTargetClick}/>
                <SelectOptions
                    id={this.id}
                    init={init}
                    value={value}
                    options={options}
                    onSelect={this.handleOptionSelect}
                    onDestroy={this.handleDestroy}/>
            </SelectContainer>
        )
    }
}
